import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import { getTemplate } from '@global/api'
import { ApiResponseTemplate } from '@templates/types'

export const KEY = 'useTemplateQuery'

interface useTemplateQueryProps {
  options?: Omit<
    UseQueryOptions<Promise<ApiResponseTemplate | null>, unknown, ApiResponseTemplate, string[]>,
    'queryKey' | 'queryFn'
  >
  id: string
}

export const useTemplateQuery = ({ options, id }: useTemplateQueryProps) =>
  useQuery({
    queryKey: [KEY, String(id)],
    queryFn: ({ signal }) => getTemplate<ApiResponseTemplate | null>({ signal, templateID: id }),
    ...options,
  })
